<template>
  <div>
    <b-button @click="showModal" variant="danger">
      {{ $t('btn.delete_player') }}
    </b-button>
    <b-modal ref="delete-player-modal">
      <p v-if="!playerHasFounds && !playerIsLocked && !errorMessage">{{ $t('label.are_you_sure') }}</p>
      <p v-if="playerHasFounds">{{ $t('label.delete_player_not_allowed_because_player_has_founds') }}</p>
      <p v-if="playerIsLocked">{{ $t('label.delete_player_not_allowed_because_player_is_locked') }}</p>
      <p v-if="errorMessage" class="alert alert-danger">{{ $t(errorMessage) }}</p>
      <template #modal-footer>
        <div>
          <b-button :disabled="playerHasFounds || playerIsLocked || errorMessage !== null"
            @click="deletePlayer"
            variant="danger"
            size="sm"
            class="float-right">
            {{ $t('btn.delete') }}
          </b-button>
        </div>
        <div>
          <b-button variant="secondary" size="sm" class="float-right" @click="hideModal">{{ $t('btn.close') }}</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ['playerId','playerIsLocked','playerHasFounds'],
  data() {
    return {
      errorMessage: null
    }
  },
  methods: {
    showModal() {
      this.$refs['delete-player-modal'].show();
    },
    hideModal() {
      this.$refs['delete-player-modal'].hide();
    },
    deletePlayer() {
      this.$store.dispatch('players/deletePlayer', this.playerId)
      .then(() => {
        this.playerIsDeleted = true;
        this.$store.dispatch('players/getPlayer', this.playerId);
        this.$store.dispatch('players/getPlayerWallet', this.playerId);
      })
      .catch(err => {
        this.errorMessage = err.response.data.label;
      });
    }
  }
}
</script>
